<script module lang="ts">
  import type { TypeFormEmbedStoryblokProps } from './typeform-embed.types';
</script>

<script lang="ts">
  import { Section } from '@agapi/ui/section';
  import { storyblokEditable } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';

  const { blok }: TypeFormEmbedStoryblokProps = $props();

  const iframeStyles = css({
    width: '100%',
    height: '600px',
    border: '0',
    borderRadius: 'md',
  });
</script>

<Section
  use={[[storyblokEditable, blok]]}
  containerWidth="normal"
  colorVariant={blok.colorVariant}
>
  <iframe
    class={iframeStyles}
    src={blok.url}
    title="Typeform"
    allow="camera; microphone; autoplay; encrypted-media; fullscreen; payment"
  >
  </iframe>
</Section>